export default function scrollToSection(id) {
  const heading = document.getElementById(id);
  if (!heading) return;
  const reducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;
  heading.focus({ preventScroll: true });
  heading.scrollIntoView({
    behavior: reducedMotion ? "auto" : "smooth",
    block: "start",
  });
}
